export default __webpack_public_path__ + "static/media/137.05938b7b.png";